import { Component, Input, OnInit } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { InputModel, QueovalDik } from '../../models';
import { BoPropertyType, DynamicTagsModel, DynamicTagsSaveModel, GetRequiredBoPropertiesModel, IBoProperty } from '../../models/bodisplay/dynamictags-inline/dynamictags-inline.model';
import { CoreService, HttpService, QueovalDateService } from '../../services';
import { ToastService } from '../../toast';

@Component({
  selector: 'q-dynamictags-inline',
  templateUrl: './dynamictags-inline.component.html',
  styleUrls: ['./dynamictags-inline.component.css']
})

export class DynamictagsInlineComponent implements OnInit {
  public properties: Array<IBoProperty<any>> = new Array<IBoProperty<any>>()
  public propsDisplayed: PropsDisplayed = PropsDisplayed.ALL;
  public forcedColumnNames: Array<string> = [];
  public exceptColumnNames: Array<string> = [];
  public DefaultInputs: Array<InputModel> = [];

  @Input() codeOrIdBo: string;
  @Input() idDonnee: string;
  @Input('forcedColumnNames') set SetForcedColumnNames(value: Array<string>)
  {
    this.forcedColumnNames = value;
  }

  @Input('exceptColumnNames') set SetExceptColumnNames(value: Array<string>) {
    this.exceptColumnNames = value;
  }

  @Input('defaultInputs') set SetDefaultInputs(value: Array<InputModel>) {
    this.DefaultInputs = value;
  }

  @Input() set SetPropsDisplayed(value: PropsDisplayed) {
    this.propsDisplayed = value;
  }

  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private qdtService: QueovalDateService,
    private toast: ToastService,
  ) { }

  public ngOnInit(): void {
    this.Load().subscribe();
  }

  public Load(): Observable<boolean> {
    const model: GetRequiredBoPropertiesModel = new GetRequiredBoPropertiesModel();
    model.idDonnee = this.idDonnee;
    model.idBO = this.codeOrIdBo;
    model.forcedColumnNames = this.forcedColumnNames;
    model.exceptColumnNames = this.exceptColumnNames;
    model.DefaultInputs = this.DefaultInputs;
    return this.http.postHttp<DynamicTagsModel>(`${this.indParam.AppParams.apiUrl}api/dynamictags/GET_REQUIRED_PROPERTIES`, model).pipe(
      map((result: DynamicTagsModel) => {
        this.properties = result.RequiredProperties;
        return result.HasAlert || result.HasError;
      }));
  }
  public HasEmptyProp(): boolean {

    let hasEmptyProp: boolean = false;
    this.properties.forEach(prop => {
      switch (prop.Type) {
        case BoPropertyType.STRING:
          if (!prop.Value) {
            prop.highlight = true;
            hasEmptyProp = true;
          }
          break;
        case BoPropertyType.DATE:
          if (!prop.Value || this.qdtService.IsNull(prop.Value)) {
            prop.highlight = true;
            hasEmptyProp = true;
          }
          break;

        case BoPropertyType.INT:
        case BoPropertyType.MONETARY:
          if (!prop.Value && prop.Value != 0) {
            prop.highlight = true;
            hasEmptyProp = true;
          }
          break;
      }
    });
    return hasEmptyProp;
  }
  public OnSave(): Observable<boolean> {
    if (this.HasEmptyProp()) {
      this.toast.showAlertToast('Veuillez renseigner les champs obligatoires.');
      return of(false);
    }

    const model: DynamicTagsSaveModel = new DynamicTagsSaveModel();
    model.IdDonnee = this.idDonnee;
    model.IdBo = this.codeOrIdBo;
    model.Properties = this.properties;
    return this.http.postHttp<boolean>(`${this.indParam.AppParams.apiUrl}api/dynamictags/SAVE_PROPERTIES`, model).pipe(map((res) => { return res }));
  }
}

export enum PropsDisplayed {
  COMBOS,
  NO_COMBOS,
  ALL
}
